<script lang="ts" setup>
import { onMounted, inject, ref, onBeforeUnmount } from 'vue';
import { Animations, ViewerEvents } from '@immersive-tech/viewer-engine';
import CollapseFieldset from '@/components/CollapseFieldset.vue';
import PlayIcon from '@/assets/images/icons8-play-8.svg?component';

import type { Ref } from 'vue';
import type { Viewer, Extension, Nullable } from '@immersive-tech/viewer-engine';

const viewer = inject('viewer') as Ref<Nullable<Viewer>>;
const animations = ref<string[]>([]);
const animationsExtension = viewer.value?.extensions.get('Animations') as Extension<Animations>;

const playAnimation = (animationName: string) => {
  if (!viewer.value) return;
  const animationActionFunction = animationsExtension.animationActionFunctions.get(animationName);

  if (animationActionFunction) animationActionFunction(undefined);
};

const updateAnimations = () => {
  if (!viewer.value) return;

  animations.value = Array.from(animationsExtension.animationActionFunctions.keys());
};

const mountHandler = () => {
  if (!viewer.value) return;

  animations.value = Array.from(animationsExtension.animationActionFunctions.keys());

  viewer.value.addEventListener(ViewerEvents.MODEL_ADDED_TO_SCENE, updateAnimations);
  viewer.value.addEventListener(ViewerEvents.MODEL_DESTROYED, updateAnimations);
};

const beforeUnmountHandler = () => {
  if (!viewer.value) return;

  viewer.value.removeEventListener(ViewerEvents.MODEL_ADDED_TO_SCENE, updateAnimations);
  viewer.value.removeEventListener(ViewerEvents.MODEL_DESTROYED, updateAnimations);
};

onMounted(mountHandler);
onBeforeUnmount(beforeUnmountHandler);
</script>

<template>
  <CollapseFieldset :enable-collapse="false">
    <template #legend>
      Play Animations
    </template>

    <div class="flex flex-col">
      <span v-if="animations.length === 0" class="text-xs">No animations loaded</span>
      <div v-for="animation in animations" :key="animation" class="flex flex-row flex-grow items-center justify-between text-white text-xs cursor-pointer px-2 mb-1 bg-blue-400 rounded-sm" @click="() => playAnimation(animation)">
        <span class="mr-1.5">{{ animation }}</span>
        <button type="button" class="flex justify-between items-center border-l pl-1">
          <PlayIcon />
        </button>
      </div>
    </div>
  </CollapseFieldset>
</template>
